"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageComponentTypeImport = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsUploadFile = require("../../components/DmsUploadFile/DmsUploadFile");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageComponentTypeImport Component
 * 
 * @description Component for importing component type files. Displays a DmsPage layout with a DmsUploadFile component for managing component type file import operations.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageComponentTypeImport />
 * )
 * 
 * @returns {JSX.Element} The Import Component Type File page.
 */
const DmsPageComponentTypeImport = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Import Component Type File"
  }, /*#__PURE__*/_react.default.createElement(_DmsUploadFile.DmsUploadFile, {
    table_url: "/component_type/files/table",
    upload_url: "/component_type/file_upload",
    import_url: "/component_type/file_import",
    download_url: "/file/download"
  }));
};
exports.DmsPageComponentTypeImport = DmsPageComponentTypeImport;